import type { AuthProvider } from '../contracts/authProvider';

interface Auth401RecoveryEntry {
  provider: AuthProvider;
  /** true = Tauri desktop only; false = web only */
  tauri: boolean;
}

// Separate from CACHE_READY_PROVIDERS on purpose: recovery-eligible desktop
// requests still read the token from Redux, not the cache.
const AUTH_401_RECOVERY_READY_PROVIDERS: ReadonlyArray<Auth401RecoveryEntry> = [
  { provider: 'AUTH0' as AuthProvider, tauri: false },
  { provider: 'AUTH0_DESKTOP' as AuthProvider, tauri: true },
];

/** Returns true when a 401 for this provider+platform may attempt recovery. */
export function isAuth401RecoveryReady(
  provider: AuthProvider | null | undefined,
  tauri: boolean
): boolean {
  if (provider === null || provider === undefined) return false;
  return AUTH_401_RECOVERY_READY_PROVIDERS.some(
    (entry) => entry.provider === provider && entry.tauri === tauri
  );
}
